import { useState, useEffect, useCallback, useRef } from 'react';

export default function useWakeLock() {
    const [wakeLock, setWakeLock] = useState(null);
    const [error, setError] = useState(null);
    // Usa un ref per tracciare se abbiamo già richiesto un lock
    const hasActiveLock = useRef(false);

    const requestWakeLock = useCallback(async () => {
        // Evita richieste multiple se c'è già un lock attivo o in corso
        if (hasActiveLock.current) return;

        try {
            if ('wakeLock' in navigator) {
                hasActiveLock.current = true;
                const lock = await navigator.wakeLock.request('screen');
                setWakeLock(lock);
                console.log('Screen Wake Lock attivato');

                lock.addEventListener('release', () => {
                    console.log('Screen Wake Lock disattivato');
                    setWakeLock(null);
                    hasActiveLock.current = false;
                });
            } else {
                console.warn('Screen Wake Lock API non supportata.');
            }
        } catch (err) {
            hasActiveLock.current = false;
            setError(err);
            console.warn(`${err.name}: ${err.message}`);
        }
    }, []);

    const releaseWakeLock = useCallback(async () => {
        if (wakeLock !== null) {
            await wakeLock.release();
            setWakeLock(null);
            hasActiveLock.current = false;
        }
    }, [wakeLock]);

    // Riapplica il lock quando la pagina torna visibile
    useEffect(() => {
        const handleVisibilityChange = async () => {
            if (document.visibilityState === 'visible' && !hasActiveLock.current) {
                await requestWakeLock();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [requestWakeLock]);

    return { wakeLock, requestWakeLock, releaseWakeLock, error };
}